import React from "react";
import styled from "styled-components";
import { inject, observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Text, Avatar, Spacer, Tooltip } from "src/components";
import { AuthStore, LogStore, SpaceStore, UserStore } from "src/stores";
import { theme } from "src/config";
import { User } from "src/models";
import { formatDistanceToNow } from "date-fns";
import { sv, enGB } from "date-fns/locale";
import { LogText } from "src/views/log";

export interface INewsfeedItemRowProps {
  spaceStore?: SpaceStore;
  userStore?: UserStore;
  authStore?: AuthStore;
  logStore?: LogStore;
  newsFeedItem?: boolean;
}

export const NewsItemRow = inject("authStore", "logStore", "userStore")(observer((props: INewsfeedItemRowProps) => {
  const { t, i18n } = useTranslation();
  const { authStore, logStore, userStore, newsFeedItem } = props;
  const user: User = authStore.getCurUser;
  const locale = i18n.language == "sv" ? sv : enGB;

  return (
    <ItemContainer>
      {logStore.logItemEntries.getArray.map((log, i) => {
        return (
          <NewsItem key={log.id} style={{ backgroundColor: i % 2 ? theme.color.slate3 : '#fff', width: '100%' }}>
            <Tooltip content={user.getFullName}>
              <Avatar
                size="default"
                image={userStore.getItemByID(log.user_id)?.getAvatar}
                initials={userStore.getItemByID(log.user_id)?.getInitials}
              />
            </Tooltip>
            <Spacer size="xxsmall" />
            <div style={{ minWidth: "fit-content", display: "flex", flexDirection: "column", marginBottom: 5 }}>
              <Text size="small" color={theme.color.slate9}>
                {userStore.getItemByID(log.user_id)?.getFullName}
              </Text>
              <Text size="xxsmall" color={theme.color.slate12}>
                {formatDistanceToNow(log.created_at, { addSuffix: true, locale })}
              </Text>
            </div>
            <Spacer size="xxsmall" />
            <LogTextWrapper newsFeedItem={newsFeedItem}>
              <Text truncated size="small">
                <LogText log={log} />
              </Text>
            </LogTextWrapper>
          </NewsItem>
        );
      })}
    </ItemContainer>
  );
})
);

const ItemContainer = styled.div`
  display:        flex;
  flex-direction: column;
  width: 100%;
`;

const LogTextWrapper = styled.div<{ newsFeedItem: boolean }>`
  width: 100%;
`

const NewsItem = styled.div`
  display:        flex;
  flex-wrap:      wrap;
  flex-direction: row;
  margin-bottom:  1rem;
  padding:        0.5rem;
  width: 100%;
`;
